import React, { useState, useEffect, useCallback } from 'react';
import VocabularyDictionary from './VocabularyDictionary';

const DictionaryPopupButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        handleClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, handleClose]);

  return (
    <>
      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 1055 }}
            onClick={handleClose}
            aria-hidden="true"
          />
          {/* Modal panel */}
          <div
            className="position-fixed bg-white rounded shadow-lg d-flex flex-column"
            style={{
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '90vw',
              maxWidth: '900px',
              height: '85vh',
              maxHeight: '700px',
              zIndex: 1060,
            }}
          >
            {/* Header */}
            <div className="d-flex align-items-center justify-content-between px-3 py-2 border-bottom bg-light" style={{ borderRadius: '0.375rem 0.375rem 0 0' }}>
              <strong>Slovník</strong>
              <button className="btn btn-sm btn-outline-secondary" onClick={handleClose}>
                Zavřít
              </button>
            </div>
            {/* Content */}
            <div style={{ flex: 1, overflowY: 'auto' }}>
              <VocabularyDictionary popupMode />
            </div>
          </div>
        </>
      )}
      {!isOpen && (
        <button
          className="btn btn-primary position-fixed bottom-0 m-4 rounded-circle shadow"
          style={{
            width: '56px',
            height: '56px',
            zIndex: 1040,
            right: 'calc(1.5rem + 56px + 1rem + 56px + 1rem)',
          }}
          onClick={() => setIsOpen(true)}
          aria-label="Otevřít slovník"
        >
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="currentColor"
          >
            <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z" />
          </svg>
        </button>
      )}
    </>
  );
};

export default DictionaryPopupButton;
